import {parseFormula,type FormulaAst} from '@/uptk/core/components/dashboard/data/formula';
import {calculationValid,type ClosedCalculation} from '@/uptk/core/components/moduleEntity/template/templateCalculation';

export type CalculationEvidence={name:string;formula:ClosedCalculation;checked:false};
// A finite, literal fingerprint of the audited recurrence. No source is evaluated.
const compoundLoop=`for (let period = 1; period <= years * frequency; period++) {
 if (options.timing === 'begin') balance += payment;
 balance *= 1 + periodRate;
 if (options.timing === 'end') balance += payment;
 finiteResult(balance, 'Capital projeté');
 if (period % frequency === 0) {
  const year = period / frequency;
  const contributed = initial + payment * period;
  const real = finiteResult(balance / Math.pow(1 + inflation / 100, year), 'Capital réel');
  rows.push({year, contributed, balance, interest: balance - contributed, real});
 }
}`;
const compact=(source:string)=>source.replace(/\s+/g,'');
function compoundEvidence(source:string):CalculationEvidence[]{
 const text=compact(source),loop=compact(compoundLoop);
 if(text.split(loop).length!==2||!text.includes('constperiodRate=Math.expm1(Math.log1p(rate/100)/frequency);')||!text.includes('letbalance=initial;'))return [];
 const states=['initial','payment','rate','years','frequency'];
 // Timing is a reviewed numeric operand: 0=end, 1=begin. Both choices remain unchecked.
 return [0,1].map(begin=>({name:begin?'compound_begin':'compound_end',checked:false,formula:{op:'compound',args:[...states.map(state=>({state})),{literal:begin}]}}));
}
const convert=(n:FormulaAst):ClosedCalculation=>{
 if(n.kind==='num')return {literal:n.value};
 if(n.kind==='ref')return {state:n.name};
 if(n.kind==='neg')return {op:'subtract',args:[{literal:0},convert(n.value)]};
 if(n.kind==='bin')return {op:({'+' :'add','-':'subtract','*':'multiply','/':'divide'} as const)[n.op as '+'|'-'|'*'|'/'],args:[convert(n.left),convert(n.right)]};
 if(n.kind==='str'||!['min','max','round','pow'].includes(n.name)||n.args.length!==2)throw Error('formula.unsupported');
 return {op:n.name==='pow'?'power':n.name as 'min'|'max'|'round',args:n.args.map(convert)};
};
/** Literal evidence only. The JavaScript is never executed, imported or attached to a template. */
export function proposeLiteralCalculations(source:string):CalculationEvidence[]{
 if(source.length>2_000_000)return [];
 const result:CalculationEvidence[]=compoundEvidence(source);
 for(const m of source.matchAll(/\bconst\s+([a-z][a-z0-9_]*)\s*=\s*([^;\r\n]{1,300});/g)){
  if(result.length>=16)break;
  try{const formula=convert(parseFormula(m[2],'calc'));if('op' in formula&&calculationValid(formula))result.push({name:m[1],formula,checked:false});}catch{/* Unsupported source stays inert. */}
 }
 return result.filter(item=>result.filter(other=>other.name===item.name).length===1);
}
export function calculationStates(formula:ClosedCalculation):string[]{return 'state' in formula?[formula.state]:'op' in formula?[...new Set(formula.args.flatMap(calculationStates))]:[];}
export function bindCalculation(formula:ClosedCalculation,bindings:Record<string,ClosedCalculation>):ClosedCalculation{
 if('state' in formula)return bindings[formula.state]??formula;
 return 'op' in formula?{...formula,args:formula.args.map(arg=>bindCalculation(arg,bindings))}:formula;
}
